import { poWorkspaceService } from '@/services/procurement/poWorkspaceService'
import type { WorkspaceNode, WorkspaceUploadInput } from '@/services/workspace'
import type { AttachmentAdapter, AttachmentItem } from './attachmentTypes'

function mapWorkspaceFile(node: WorkspaceNode): AttachmentItem {
  return {
    id: node.id,
    fileName: node.name,
    mimeType: node.mimeType ?? 'application/octet-stream',
    sizeBytes: node.size ?? 0,
  }
}

export function createPoWorkspaceAttachmentAdapter(poId: string): AttachmentAdapter {
  return {
    async list() {
      const nodes = await poWorkspaceService.list(poId, 'attachments', null)
      return nodes.filter((node) => node.kind === 'file').map(mapWorkspaceFile)
    },

    async upload(_entityType, _entityId, files) {
      const inputs: WorkspaceUploadInput[] = files.map((file) => ({
        name: file.name,
        mimeType: file.type || undefined,
        size: file.size,
        file,
      }))
      const uploadedNodes = await poWorkspaceService.uploadFiles(poId, 'attachments', null, inputs)
      const rejected = uploadedNodes.uploadErrors ?? []
      const uploadedIndexes = uploadedNodes.uploadIndexes ?? uploadedNodes.map((_, index) => index)
      const uploadedByIndex = new Map(uploadedNodes.map((node, nodeIndex) => [uploadedIndexes[nodeIndex]!, node]))

      return files.map((file, fileIndex) => {
        const uploadedNode = uploadedByIndex.get(fileIndex)
        if (uploadedNode) {
          return { file, item: mapWorkspaceFile(uploadedNode) }
        }

        const failure = rejected.find((candidate) => candidate.name === file.name && candidate.index === fileIndex)
        return {
          file,
          error: failure?.message ?? 'Không thể tải tệp lên.',
        }
      })
    },

    async remove(fileId) {
      await poWorkspaceService.remove(poId, 'attachments', [fileId])
    },

    contentUrl(item) {
      return poWorkspaceService.contentUrl(item.id)
    },
  }
}

export const poWorkspaceAttachmentAdapter = createPoWorkspaceAttachmentAdapter
